import { render, staticRenderFns } from "./DocDraftOrgFlag.vue?vue&type=template&id=25b15418&"
import script from "./DocDraftOrgFlag.vue?vue&type=script&lang=js&"
export * from "./DocDraftOrgFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports